/**
 * @version: 2.1.0
 * @author: John Bandy, john@concatsys.com
 * @company: Concat Systems, Inc.
 *
 * @description: Provides a serialized API for gyroscope functionality across 
 * devices, and handles communication between frames. 
 *
 * @copyright 2020 Concat Systems, Inc.
 *
 * {@link https://github.com/ConcatSystems/ConcatJS}
 */


// imports
import { Environment } from "./Environment.js";
import { GyroErrors } from "./GyroErrors.js";
import { PermissionStatuses } from "./PermissionStatuses.js";
import { States } from "./States.js";

import parent from "./Gyro.parent.js";
import child from "./Gyro.child.js";


let Gyro = {

  // version control this shit!
  VERSION            : "2.1.0",

  // set up access
  Env                : Environment,
  PermissionStatuses : PermissionStatuses,
  States             : States,
  Errors             : GyroErrors,
  child              : child,
  parent             : parent
};

// done! export this bitch!
export { Gyro };
